<template>
  <div>

    <v-row>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <CommonDropDowns :isItTaxYearWithoutAllYears=true
            @change="dataFromCommonDropDowns" :taxYearValue="editedItem.taxYear"
            :isTaxYearWithoutAllDisabled=true />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-5"
           small hide-details dense label="Tax Unit" v-model="editedItem.taxUnit" readonly>
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-2"
           small hide-details dense label="Tax Fund"  v-model="editedItem.fundNumber"
           readonly>
          </v-text-field>
      </v-col><v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-2"
           small hide-details dense label="Description"
           v-model="editedItem.taxFundDescription" readonly>
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-4 pb-0 mb-n4">
        <!-- <v-text-field class="input-text-size mt-4"
           small  dense label="Priority" v-model.number="editedItem.priority"
           >
          </v-text-field> -->
         <v-select id="input-text-size"
          class="input-text-size"
            v-model.number="editedItem.priority"
            :items="priorityList"
            label="Priority"
          ></v-select>
      </v-col><v-col cols="6" class="pt-4 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Expected Amount"
           v-model.number="editedItem.expectedAmount"
            @blur="roundAmount('expectedAmount')"
          @focus="amountToNum('expectedAmount')"
           :readonly="isAdmin" :tabindex="isAdmin ? -1 : 0" >
          </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small hide-details dense label="Collected Amount" readonly tabindex="-1"
           v-model.number="editedItem.collectedAmount"
            @blur="roundAmount('collectedAmount')"
          @focus="amountToNum('collectedAmount')"
          >
          </v-text-field>
      </v-col><v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size my-4"
           small  dense label="Uncollected Amount"
           :rules="totalTaxVaidation"
          v-model.number="editedItem.unCollectedAmount"
           @blur="roundAmount('unCollectedAmount')"
          @focus="amountToNum('unCollectedAmount')"
          :readonly="isAdmin" :tabindex="isAdmin ? -1 : 0">
          </v-text-field>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
}
  from 'vuex';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'ExemptMfgApportionmentDialog',
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      priorityList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'isVisible']),
    ...mapGetters('auth/token', [
      'authUserRoles',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },

    taxStillDue() {
      return amountToNumber(this.editedItem.totalDue) - amountToNumber(this.editedItem.totalPaid);
    },
    taxPaidNoProtest() {
      return amountToNumber(this.editedItem.totalPaid)
      - amountToNumber(this.editedItem.amountPaidUnderProtest);
    },
    totalTaxVaidation() {
      const isExceedLimit = (this.editedItem.amountPaidUnderProtest
       + this.editedItem.amountPaidNoProtest)
       > this.editedItem.totalDue;

      return [
        () => !isExceedLimit || 'protest and non protest amount is not equal of tax due',
      ];
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    isAdmin: {
      get() {
        if (this.authUserRoles.includes('TmcSupport') || this.authUserRoles.includes('TaxAdministration')) {
          return false;
        }
        return true;
      },
    },
  },
  watch: {
    isVisibleProp: {
      handler() {
        if (this.isVisibleProp) {
          const keys = ['expectedAmount', 'collectedAmount', 'unCollectedAmount'];
          keys.forEach((key) => {
            this.roundAmount(key);
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    roundAmount(f) {
      this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
    },
    // These three boxes are readonly rather than disabled now, so a click still focuses them and
    // runs this. It strips the formatting off editedItem, which would stick if the dialog closed
    // before blur. Only the focus direction is gated - roundAmount is also the display formatter
    // (see the isVisibleProp watcher above) and has to stay open for all three fields.
    amountToNum(f) {
      if (f === 'collectedAmount' || this.isAdmin) return;
      this.editedItem[f] = amountToNumber(this.editedItem[f]);
    },

  },
};
</script>

<style>
.add-border {
  border: 1px solid grey !important;
}
</style>
